import React, { Component } from "react";
import Row from "../Row";
import Col from "../Col";
import FontAwesomeIcon from "../Icon";
import EmptyImage from "./EmptyImage";
import "./HomeOwnerDashboard.scss";
import Overlay from "../Overlay";
import { onImageExtensionExist } from "../../helpers/CommonHelpers";

class DocumentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusPdf: false,
      pdfUrl: "",
      embed: false,
    };
  }
  setPdf = () => {
    this.setState({
      statusPdf: false,
    });
  };
  openIframe = (url, embed) => {
    if (this.state.statusPdf === false) {
      this.setState({
        statusPdf: true,
        pdfUrl: url,
        embed: embed ? true : false,
      });
    }
  };
  imageViewer = (img, embed) => {
    if (onImageExtensionExist(img)) {
      return <img src={img} style={{ display: "flex", margin: "auto" }} />;
    } else {
      if (embed) {
        // console.log('JSON.parse(img)--->',JSON.parse(img))
        return (
          <div
            style={{ height: "180px" }}
            dangerouslySetInnerHTML={{ __html: `${img} ` }}
          />
        );
      } else {
        return (
          <>
            <iframe
              style={{ width: "100%", height: "100%" }}
              src={
                "https://docs.google.com/gview?url=" + img + "&embedded=true"
              }
              // width="100%"
              // height="530"
              style={{ overflow: "hidden", height: "90%", width: "100%" }}
            ></iframe>
          </>
        );
      }
    }
  };
  render() {
    const { data, onDownloadDocument } = this.props;
    return (
      <div className="homeDasboard__mainTile">
        <div style={{ padding: 20 }}>
          <label className="homeDasboard__title">MANUALS & DOCUMENTS</label>
          {data && data.length > 0 ? (
            <div className="homeDasboard__tile">
              <div style={{ display: "flex" }}>
                <div className="homeDasboard__tableItem">Guide</div>
              </div>
              <div className="homeDasboard__list">
                {data.map((item, i) => {
                  return (
                    <div className="homeDasboard__table" key={i}>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <label
                            className="homeDasboard__date"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.openIframe(
                                item.document
                                  ? item.document
                                  : item.Embed
                                  ? item.Embed
                                  : item.image,
                                item.Embed ? true : false
                              )
                            }
                          >
                            {item.name}
                          </label>
                        </div>
                        {item.Embed ? null : (
                          <div
                            className="homeDasboard__icon"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              onDownloadDocument(
                                item.document ? item.document : item.image
                              )
                            }
                          >
                            <FontAwesomeIcon
                              glyph="download"
                              weight="solid"
                              size="small"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <EmptyImage
              text="You have no Manuals & Documents."
              width={200}
              height={120}
              image={"/assets/empty/documents.svg"}
            />
          )}
        </div>
        <Overlay
          showOverlay={this.state.statusPdf}
          content={
            <div
              style={{
                width: "80%",
                margin: "auto",
                padding: "5px",
                height: "90%",
              }}
            >
              <div style={{ padding: "10px" }}>
                <button
                  type="button"
                  className="form__dismiss"
                  style={{ color: "#454F5B" }}
                  onClick={() => this.setPdf()}
                >
                  <FontAwesomeIcon weight="light" glyph="arrow-left" />
                </button>

                <span
                  className="heading-with-details__headline"
                  style={{ padding: "0px 50px" }}
                >
                  Manuals & Documents
                </span>
              </div>
              {this.imageViewer(this.state.pdfUrl, this.state.embed)}
            </div>
          }
        ></Overlay>
      </div>
    );
  }
}
export default DocumentsList;
